module.exports = "\n<router-outlet>\n\t\n</router-outlet> "


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 422
// module chunks = 1